(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSetupSelectGateways (
    NetworkListService, $timeout, $filter, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        onlyUploadConfiguration: '=onlyUploadConfiguration',
        paginationObject: '=paginationObject',
        tenant: '=tenant',
        callback: '&callback'
      },
      templateUrl: 'app/components/setup/setupSelectGateways/setupSelectGateways.template.html',
      link: function(scope) {

        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';
        var url = scope.tenant.info._links['px:unknownNetworks2'].href;



        (function() {
          setPosition()
          getFirstPage();
        })();

        function setPosition () {
          let element =  document.querySelector('.select-fake-list-float')
          let elementRatio = element.getBoundingClientRect()
          if ((elementRatio.bottom + 30) > window.innerHeight) {
            element.style.top = `-${elementRatio.bottom - window.innerHeight}px`
          }
        }



        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 10;
          scope.list = [];
          scope.loadingPage = true;

          $http.get(url + scope.paginationObject.getPagedUrlParameters()).then(function(response) {
            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = response.data.page.totalPages;
            if (response.data._embedded && response.data._embedded['px:unknownNetworkResources']) {
              scope.list = response.data._embedded['px:unknownNetworkResources'];
            }
          }).catch(function(error){
            console.log(error);
          });
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          scope.list = [];
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;

            $http.get(url + scope.paginationObject.getPagedUrlParameters()).then(function(response) {
              if (response.data._embedded['px:unknownNetworkResources']) {
                scope.list = scope.list.concat(response.data._embedded['px:unknownNetworkResources']);
              }
              scope.loadingPage = false;
            }).catch(function(error){
              console.log(error);
            });
          }
        }

        angular.element('.pagination-small-results').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });



        scope.$on('$destroy', function() {
          angular.element('.pagination-small-results').off('scroll');
        });

        scope.selectItem = function (event, selectedItem) {
          event.stopPropagation();
          scope.callback({selectedItem: selectedItem})
        }

        scope.closePopup = function (event) {
          scope.callback({selectItem: null});
        }


        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch(tooltipScope) {
              case 'networkTooltip':
                networkTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function networkTooltip (position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'networkAllDetails',
            network: context,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 500},
            contextMenu: false
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

      }
    };
  }

  pxSetupSelectGateways.$inject = ['NetworkListService', '$timeout', '$filter', '$http'];

  angular
    .module('printix-admin')
    .directive('pxSetupSelectGateways', pxSetupSelectGateways);

})();
